import { render, staticRenderFns } from "./PaidChats.vue?vue&type=template&id=74107482&%23allPaids=true"
import script from "./PaidChats.vue?vue&type=script&lang=js"
export * from "./PaidChats.vue?vue&type=script&lang=js"
import style0 from "./PaidChats.vue?vue&type=style&index=0&id=74107482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports